module.exports = __webpack_public_path__ + "static/media/april-youtube.3a4e9028.jpg";